import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
  

const ReceiveBulkStakeCreate = ()=>{
     const [betid, setBetid ] = useState('');
     const [customerId, setCustomerId ] = useState('');
     const [mobileNo, setMobileNo ] = useState('');
     const [punterAmt, setPunterAmt ] = useState('');
     const [desc, setDesc ] = useState('');
     const [stakeAmt, setStakeAmt ] = useState('');
     const [stakeType, setStakeType ] = useState('');
     const [odds, setOdds ] = useState('');
     const [dateOfStake, setDateOfStake ] = useState('');
     const [exciseAmt, setExciseAmt ] = useState('');
     const [walletBalanceStake, setWalletBalanceStake ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('receiveBulkStake', {
            betid,
            customerId,
            mobileNo,
            punterAmt,
            desc,
            stakeAmt,
            stakeType,
            odds,
            dateOfStake,
            exciseAmt,
            walletBalanceStake,
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/receiveBulkStakes'} />
    }
     return (
         <Wrapper pageTitle={"New Stake Data"}>
            <InnerNav createLink={'/receiveBulkStakeCreate'} listLink={'/receiveBulkStakes'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Bet id </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Betid"
                        onChange = {e => setBetid(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Customer Id </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="CustomerId"
                        onChange = {e => setCustomerId(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Mobile No </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="MobileNo"
                        onChange = {e => setMobileNo(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Punter Amt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="PunterAmt"
                        onChange = {e => setPunterAmt(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Desc </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Desc"
                        onChange = {e => setDesc(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Stake Amt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="StakeAmt"
                        onChange = {e => setStakeAmt(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Stake Type </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="StakeType"
                        onChange = {e => setStakeType(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Odds </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Odds"
                        onChange = {e => setOdds(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Date Of Stake </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="DateOfStake"
                        onChange = {e => setDateOfStake(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Excise Amt </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ExciseAmt"
                        onChange = {e => setExciseAmt(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Wallet Balance Stake </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="WalletBalanceStake"
                        onChange = {e => setWalletBalanceStake(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default ReceiveBulkStakeCreate;